import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  OnInit,
} from '@angular/core';
import { AnexoPrecargaResponseDto } from '../../../dto/anexo/anexo-tramite.dto';
import { AnexoService } from '../../../services/anexo.service';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'app-cargue-archivos',
  templateUrl: './cargue-archivos.component.html',
  styleUrl: './cargue-archivos.component.scss',
})
export class CargueArchivosComponent implements OnChanges {
  @Output() cargar = new EventEmitter<File[]>();
  @Output() eliminar = new EventEmitter<File>();
  @Output() archivosCargados = new EventEmitter<File[]>();


  @Input() etiqueta = '';
  @Input() requerido = false;
  @Input() reglaArchivo = '';
  @Input() tamanioMin = 0;
  @Input() tamanioMax?: number;
  @Input() extensiones = '';
  @Input() descripcionRegla? = '';
  @Input() documentoGuia? = '';
  @Input() urlGuia? = '';
  @Input() precargaArchivos?: any[] = [];
  @Input() cantidadMaxAchivos?: number;
  inputName = 'inputFile' + Math.random().toString(36).substring(7);

  files: File[] = [];
  listaArchivos: File[] = [];
  selectedFileName = '';

  error = false;
  mensajeError = '';

  // Multilenguaje
  tableText: any = {};
  constructor(
    private anexoService: AnexoService,
    private translate: TranslateService
  ) {
    // Multilenguaje
    this.translate.stream('carga-archivos').forEach(text => {
      for (let key of Object.keys(text)) {
        this.tableText[key] = text[key];
        this.selectedFileName = this.tableText['sin-archivo'];
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['precargaArchivos']) {
      if (this.precargaArchivos && this.precargaArchivos.length > 0) {
        this.precargaArchivos.map(archivo => {
          const tamanio = parseInt(archivo.tamano);
          const content = new Uint8Array(tamanio);
          this.files.push(new File([content], archivo.nombreArchivo));
        });
        setTimeout(() => {
          this.uploadFile();
        }, 600);
      }
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files) {
      const files = Array.from(input.files);

      for (const file of files) {
        this.files.push(file);
      }

      input.value = '';
      this.selectedFileName = files.map(file => file.name).join(', ');
    }
  }

  uploadFile(): void {
    let entidadSeleccionada = sessionStorage.getItem(Constants.TRAMITE_SELECCIONADO);
    if (this.files) {
      for (const file of this.files) {
        // Verifica si el archivo ya está en la lista
        const fileExists = this.listaArchivos.some(
          existingFile => existingFile.name === file.name
        );

        if (!fileExists) {
          // Valida nombre, extension y peso del archivo
          const regex = new RegExp(this.reglaArchivo);
          const extensiones = this.extensiones
            .split(',')
            .map(ext => ext.trim().toLowerCase());

          const nombreArchivo = file.name.split('.').slice(0, -1).join('.');
          const extensionArchivo =
            '.' + file.name.split('.').pop()?.toLowerCase();

          if (
            regex.test(nombreArchivo) &&
            (this.tamanioMax == null ||
              this.tamanioMax === 0 ||
              this.bytesToKb(file.size) <= this.tamanioMax) &&
            this.bytesToKb(file.size) >= this.tamanioMin &&
            extensiones.includes(extensionArchivo)
          ) {
            this.listaArchivos.push(file);
            this.error = false;
            this.files = [];
          } else {
            this.error = true;
            this.files = [];
            this.selectedFileName = this.tableText['sin-archivo'];

            if (!regex.test(nombreArchivo)) {
              this.mensajeError = `${this.tableText['error-nombre']} ${this.descripcionRegla}`;
            }
            if (
              this.tamanioMax != null &&
              this.tamanioMax > 0 &&
              this.bytesToKb(file.size) >= this.tamanioMax
            ) {
              this.mensajeError = `${this.tableText['error-maximo']} (${this.bytesToKb(file.size)} Kb)`;
            }
            if (this.bytesToKb(file.size) <= this.tamanioMin) {
              this.mensajeError = `${this.tableText['error-minimo']} (${this.bytesToKb(file.size)} Kb)`;
            }
            if (!extensiones.includes(extensionArchivo)) {
              this.mensajeError = this.tableText['error-extension'];
            }
          }

          this.selectedFileName =
            this.files[0]?.name || this.tableText['sin-archivo'];
        } else {
          if (entidadSeleccionada?.includes(Constants.DNDA)) {
            let count: number = Constants.MIN_COUNT;
            this.listaArchivos.forEach(elemento => {
              elemento.name == file.name;
              count++;
            })
            if (count > Constants.MAX_COUNT) {
              this.mensajeError = `${this.tableText['archivo']} ${file.name} ${this.tableText['lista']}`;
              this.error = true;
            }
          } if (entidadSeleccionada?.includes(Constants.DIMAR)) {
            let count: number = Constants.MIN_COUNT;
            this.listaArchivos.forEach(elemento => {
              elemento.name == file.name;
              count++;
            })
            if (count > Constants.MAX_COUNT) {
              this.mensajeError = `${this.tableText['archivo']} ${file.name} ${this.tableText['lista']}`;
              this.error = true;
            }
          } else {
            this.mensajeError = `${this.tableText['archivo']} ${file.name} ${this.tableText['lista']}`;
            this.error = true;
          }
        }
      }
    }
    // Emite la lista de archivos al componente principal
    this.cargar.emit(this.listaArchivos);
    this.archivosCargados.emit(this.listaArchivos);

  }

  aDocumentoGuia() {
    if (this.documentoGuia) {
      this.anexoService
        .descargarAnexo(this.documentoGuia)
        .subscribe((response: Blob) => {
          const blob = new Blob([response]);
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.download =
            this.documentoGuia?.split('/').pop() || 'documentoGuia.pdf';
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(anchor);
        });
    }
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      this.aDocumentoGuia();
    }
  }

  removeFile(archEliminado: File): void {
    this.listaArchivos = this.listaArchivos.filter(
      file => file !== archEliminado
    );

    // Emite el archivo eliminado y la lista actualizada
    this.eliminar.emit(archEliminado);
    this.archivosCargados.emit(this.listaArchivos);
    this.cargar.emit(this.listaArchivos);

    if (this.listaArchivos.length === 0) {
      this.selectedFileName = this.tableText['sin-archivo'];
    }
  }

  bytesToKb(bytes: number): number {
    const kb = bytes / 1024;
    return Number(kb.toFixed(2));
  }
}
